<template>
  <div :class="$file.content">
    <div :class="$file.main">
      <vue-custom-scrollbar class="scroll-area"
                            :settings="settings">
        <div :class="$file.mainContent">
          <app-help />
          <img src="@/assets/img/ic_cover_fill.png" alt="">
          <h1>I will contact the IRS myself</h1>
          <p :class="$file.note">We make it easy to file and negotiate with the IRS yourselves.</p>
          <div :class="$file.formBox">
            <h3>Submit to IRS</h3>
            <p>
              The program will provide you with all the required IRS Forms you need
              to successfully negotiate a Tax Settlement with the IRS by yourself.
              This does however require some advanced negotiating skills, determination
              and patience. An alternative solution is to be professionally represented
              before the IRS by one of our Tax Professional licensed to practice before
              the IRS. To do so <router-link :to="{
                params: { id: this.geCPAId },
                name: 'decision',
              }">click here.</router-link>
            </p>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>
    <div :class="$file.footer">
      <app-button text="Back"
                  button-style="default"
                  @click="goBack"
                  :class="$file.backBtn">
        <app-svg-icon name="ic_back"
                      :class="$file.backIcon"/>
      </app-button>

      <app-button text="Next"
                  button-style="accent"
                  @click="goNext"
                  :class="$file.continueBtn">
      </app-button>
    </div>
  </div>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      settings: {
        wheelSpeed: 0.5,
      },
    };
  },
  components: {
    VueCustomScrollbar,
  },
  methods: {
    ...mapActions([
      'getFormProgress',
    ]),
    goBack() {
      this.getFormProgress(this.getUserId);
      this.$router.push({
        params: { id: this.getCPAId },
        name: 'decision',
      }).catch(() => {});
    },
    goNext() {
      this.getFormProgress(this.getUserId);
      this.$router.push({
        params: { id: this.getCPAId },
        name: 'account-info',
      }).catch(() => {});
    },
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getCPAId',
    ]),
  },
};
</script>

<style src="@/styles/file.scss" lang="scss" module="$file"></style>
